import { MyConversationsState } from './_types';

export const initialState: MyConversationsState = {
    myConversations: null,
};
